import { render, staticRenderFns } from "./ImpersonationDropdown.vue?vue&type=template&id=0f6a4454&scoped=true"
import script from "./ImpersonationDropdown.vue?vue&type=script&lang=js"
export * from "./ImpersonationDropdown.vue?vue&type=script&lang=js"
import style0 from "./ImpersonationDropdown.vue?vue&type=style&index=0&id=0f6a4454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6a4454",
  null
  
)

export default component.exports